export const dischargeDateExists = (dischargeValues, index) =>
  dischargeValues && index < dischargeValues.length && dischargeValues[index]["discharge_date"];
